import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import faTranslation from './locales/fa/translation.json';

const resources = {
  en: { translation: enTranslation },
  fa: { translation: faTranslation },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lng') ?? 'fa',
  fallbackLng: localStorage.getItem('lng') ?? 'fa',
  interpolation: {
    escapeValue: false,
  },
});
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('lng', lng);
});

export default i18n;
